<template>
  <div class="services-box">
    <menuBox :step="3"></menuBox>
    <div class="title-box">
      <div class="title">
        <p>เกี่ยวกับเรา</p>
        <span>ในฐานะผู้นำที่มุ่งมั่นในการแปรรูปและการผลิตโลหะ
          เราแสวงหานวัตกรรมทางเทคโนโลยีและความเป็นเลิศด้านคุณภาพอย่างต่อเนื่องเพื่อสร้างมูลค่าและความสำเร็จให้กับพันธมิตรในอุตสาหกรรมต่างๆ</span>
      </div>
    </div>
    <div class="poptfplio">
      <div class="title">ความใส่ใจในรายละเอียดทำให้เกิดงานโลหะที่แม่นยำตามที่คุณต้องการ</div>
      <div class="text">เรามุ่งเน้นที่รายละเอียดและคุณภาพโดยยึดลูกค้าเป็นศูนย์กลาง
        บรรลุการผลิตและการส่งมอบผลิตภัณฑ์โลหะที่แม่นยำผ่านทีมงานที่ยอดเยี่ยมและอุปกรณ์ที่ทันสมัย</div>
      <div class="imgList">
        <img src="../assets/poptfplio1.png" alt="">
        <img src="../assets/poptfplio2.png" alt="">
        <img src="../assets/poptfplio3.png" alt="">
        <img src="../assets/poptfplio4.png" alt="">
      </div>
      <div class="imgList">
        <img src="../assets/poptfplio5.png" alt="">
        <img src="../assets/poptfplio6.png" alt="">
        <img src="../assets/poptfplio7.png" alt="">
        <img src="../assets/poptfplio8.png" alt="">
      </div>
    </div>
    <div class="advantage">
      <div class="title">ข้อได้เปรียบของเรา</div>
      <div class="text">ความมุ่งมั่นของเราคือคุณภาพและความน่าเชื่อถือ ทำให้คุณมั่นใจในการเลือกผลิตภัณฑ์โลหะที่ดีที่สุด
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <p>เทคโนโลยีกระบวนการที่ยอดเยี่ยม:</p>
          <span>เรามีอุปกรณ์แปรรูปโลหะขั้นสูงและงานฝีมืออันประณีตเพื่อให้มั่นใจถึงประสิทธิภาพและผลผลิตคุณภาพสูงในกระบวนการผลิตผลิตภัณฑ์</span>
        </div>
        <div class="item">
          <img src="../assets/advantage2.png" alt="">
          <p>การประกันคุณภาพ:</p>
          <span>เราปฏิบัติตามมาตรฐานระบบการจัดการคุณภาพ ISO
            อย่างเคร่งครัดและรับรองว่าแต่ละผลิตภัณฑ์ตรงตามมาตรฐานคุณภาพสูงสุดผ่านกระบวนการตรวจสอบคุณภาพที่เข้มงวดและวิธีการทดสอบ</span>
        </div>
        <div class="item">
          <img src="../assets/advantage3.png" alt="">
          <p>นวัตกรรมและการวิจัยและพัฒนา:</p>
          <span>เราลงทุนอย่างต่อเนื่องในการวิจัยและพัฒนาและนวัตกรรมเพื่อเป็นผู้นำแนวโน้มการพัฒนาเทคโนโลยีของอุตสาหกรรม
            และมอบการออกแบบผลิตภัณฑ์และโซลูชั่นล่าสุดแก่ลูกค้า</span>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    };
  },
  mounted() { },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.services-box {
  .title-box {
    background-image: url(../assets/services.png);
    width: 100%;
    height: 420px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 240px 360px 0 360px;
    text-align: center;
    box-sizing: border-box;

    .title {
      float: right;
      width: 600px;
      text-align: right;

      p {
        margin-bottom: 20px;
        font-size: 56px;
        color: #FFFFFF;
        line-height: 67px;
      }

      span {
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
}

.poptfplio {
  padding: 100px 0;

  .title {
    padding: 0 360px;
    margin-bottom: 24px;
    font-size: 40px;
    color: #333333;
    line-height: 48px;
  }

  .text {
    margin-bottom: 48px;
    padding: 0 360px;
    font-size: 16px;
    color: #333333;
    line-height: 28px;
  }

  .imgList {
    display: flex;

    img {
      width: 480px;
    }

  }
}

.advantage {
  padding: 0 360px 100px;
  text-align: center;

  .title {
    margin-bottom: 28px;
    padding: 12px 0;
    font-size: 32px;
    color: #F65331;
    line-height: 38px;
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
  }

  .text {
    margin-bottom: 48px;
    font-size: 16px;
    color: #999999;
    line-height: 28px;
  }

  .itemBox {
    display: flex;
    justify-content: space-between;

    .item {
      width: 33.3%;
      margin-right: 100px;

      img {
        margin-bottom: 24px;
        width: 160px;
        height: 160px;
      }

      p {
        margin-bottom: 8px;
        font-size: 24px;
        color: #333333;
        line-height: 29px;
      }

      span {
        font-size: 16px;
        color: #999999;
        line-height: 28px;
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}
</style>
